import { $get, $movaGet } from '../axios';

// 数据总览-总览
export const getMapAllOverview = params => {
  return $get('/creator/', { act: 'get_all_map_overview', ...params });
};
// 地图列表
export const getMapList = params => {
  return $get('/creator/', { act: 'get_map_list', ...params });
};
// 地图详情
export const getMapDetail = params => {
  return $get('/creator/', { act: 'get_map_overview', ...params });
};
// 地图详情-曲线图
export const getMapDiagram = params => {
  return $get('/creator/', { act: 'get_map_diagram', ...params });
};
// 下载
export const exportMapData = params => {
  return $get('/creator/', { act: 'export_map_data', ...params });
};
// 下载自定义埋点数据
export const exportMapCustomData = params => {
  return $get('/creator/', { act: 'export_map_stats', ...params });
};
export const downloadData = params => {
  return $get('/creator/', { act: 'export_maps_ugc', ...params });
};
//曝光转化数据
export const getExportsureData = params => {
  return $get('/creator/', { act: 'get_map_ad_exposure', ...params });
};
//获取活跃数据
export const getActiveData = params => {
  return $get('/creator/', { act: 'get_maps_ugc', ...params });
};
//获取用户所有地图激励数据
export const getMotivate = params => {
  return $movaGet('/encourage/', { web: 'all', ...params });
};
//获取单张地图激励数据
export const getSinMotivate = params => {
  return $movaGet('/encourage/', { web: 'single', ...params });
};
//获取单张地图日维度数据
export const getMapDaysDetail = params => {
  return $get('/creator/', { act: 'get_platform_stats_day', ...params });
};
//获取单张地图激励数据
export const setCloseRoom = params => {
  return $get('/creator/', { act: 'close_room', ...params });
};
